import { render, staticRenderFns } from "./ParcelsTable.vue?vue&type=template&id=39f6a841&"
import script from "./ParcelsTable.vue?vue&type=script&lang=js&"
export * from "./ParcelsTable.vue?vue&type=script&lang=js&"
import style0 from "./ParcelsTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports